import React from 'react';

import { currencyFormat, powerFormat } from '../../services/tools/TypeHelper';

import { ReactComponent as IconLightning } from '../../assets/icons/synthese/icon-lightning.svg';
import { PackageData_Battery } from '../../services/calculs/package';
import { caculSimulationComplete } from '../../services/calculs/simulationComplete';
import { useRecoilValue } from 'recoil';
import { themesStateAtom } from '../../services/Recoil/Atom/Themes.atom';
import { dummyInstallationPV } from '../../services/calculs/installationPV';
import { getPrixKwhRevente } from '../../services/calculs/calculPhotovoltaique';
import { calculProjectionFinanciereGlobale } from '../../services/calculs/applyPreconisation';
import { DepenseParPoste } from '../../services/calculs/bilanEnergieService';
import { ProjectionFinanciere } from '../../services/calculs/applyPreconisation';
import { DUREE_PROJETCTION_FINANCIERE } from '../../services/calculs/calculEconomie';
import DivDebug from '../DivDebug/DivDebug';
// import { prettyLog } from '../../services/tools/auditTools';

const BattContainerComponent: React.FC<PackageData_Battery> = (card: React.PropsWithChildren<PackageData_Battery>) => {
    const themes = useRecoilValue(themesStateAtom);

    // A partir des déclarations présente dans l'audit, on calcule le cout, par poste energetique.

    // TODO : check ce qui se passe avec dummyinstallation ici !
    const { depenseInitiale, depenseApresTravaux, simuPv, bilanPv, simuBatt, bilanBatt } = caculSimulationComplete(
        themes,
        card.installationPV ?? dummyInstallationPV(),
        card.puissance ?? 0
    ); //, panneau);
    if (!simuPv) {
        throw new Error('No simuPv found');
    }

    if (!bilanBatt) {
        throw new Error('No bilanBatt found');
    }
    let currentProjectionFinanciere: ProjectionFinanciere = {
        economieHorsPV: new DepenseParPoste(),
        economiePV: { autoconsomation: 0, revente: 0, total: 0 },
        economieBatt: { autoconsomation: 0, revente: 0, total: 0 },
        projectionsAnnuelles: [],
        rendement: 0,
    };
    // normalement ici, comme on a un panneau solaire, donc on a simuPv, et bilanPv non undefined.
    // Mais typescript fait chier alors on élimine ce cas dans le code.
    if (simuPv !== undefined && bilanPv !== undefined) {
        currentProjectionFinanciere = calculProjectionFinanciereGlobale(
            depenseInitiale,
            depenseApresTravaux,
            simuPv,
            bilanPv,
            simuBatt,
            bilanBatt,
            11382, // WTF ??? // TODO : voir si on peut pas enlever ce magic number d'initialisation.
            DUREE_PROJETCTION_FINANCIERE
        );
    } else {
        console.log('something run very very very bad, in ModeProductionPVContainerComponent.');
    }

    const deltaRevente = bilanBatt.avant.potentielRestitution - bilanBatt.apres.nonRestituable;

    const prixDachat = depenseInitiale.electricitePrice.unitPrice;
    const prixKwhRevente = getPrixKwhRevente(card.installationPV?.modeConsommation ?? 'Autoconsommation', card.installationPV?.panneau?.puissance ?? 0);

    // if (card.applicable) {
    //     console.log(
    //         'economie In Batt = ' +
    //             JSON.stringify(
    //                 {
    //                     economieHorsPV: currentProjectionFinanciere.economieHorsPV.prix(),
    //                     economieBatt: currentProjectionFinanciere.economieBatt,
    //                     economiePV: currentProjectionFinanciere.economiePV,
    //                     y0: currentProjectionFinanciere.projectionsAnnuelles[0],
    //                 },
    //                 null,
    //                 2
    //             )
    //     );
    //     console.log('bilanBatt In Batt = ' + JSON.stringify(bilanBatt, null, 2));
    // }

    return (
        <div className="card-col-body--production">
            <h5>
                Restitution
                <IconLightning width="24" height="24" />
            </h5>
            <ul className="card-col-production--list">
                <>
                    <li>
                        Autoconso./25ans<span>{currencyFormat(currentProjectionFinanciere.economieBatt.autoconsomation)}</span>
                    </li>
                    {card.installationPV?.modeConsommation === 'ReventeSurplus' && (
                        <>
                            <li>
                                Revente sur 20ans<span>{currencyFormat(currentProjectionFinanciere.economieBatt.revente)}</span>
                            </li>

                            <li>
                                Total sur 25 ans<span>{currencyFormat(currentProjectionFinanciere.economieBatt.total)}</span>
                            </li>
                        </>
                    )}{' '}
                    {/* <li>
                        Autoconso. 1ere année <span>+ {powerFormat(Math.round(bilanBatt.apres.restitution))} kWh</span>
                    </li> */}
                    <li>
                        Autoconso. 1ere année <span>+ {currencyFormat(Math.round(bilanBatt.apres.restitution * prixDachat))}</span>
                    </li>
                    {/* <li>
                        Revente 1ere année <span>- {powerFormat(Math.round(bilanBatt.apres.restitution))} kWh</span>
                    </li> */}
                    {card.installationPV?.modeConsommation === 'ReventeSurplus' && (
                        <>
                            <li>
                                Revente 1ere année <span>- {currencyFormat(Math.round(deltaRevente * prixKwhRevente))}</span>
                            </li>
                            <li>
                                Economie 1ere année <span>+ {currencyFormat(Math.round(bilanBatt.apres.restitution * (prixDachat - prixKwhRevente)))}</span>
                            </li>
                        </>
                    )}
                </>
                <DivDebug>
                    <>
                        <hr />
                        <li>
                            Prod pv : <span>{powerFormat(Math.round(simuPv.maxProd()))} kWh</span>
                        </li>
                        <li>
                            Stockage (365*{card.puissance}k*80%) : <span>{powerFormat(Math.round(bilanBatt.stockage))} kWh</span>
                        </li>
                        <li>
                            potentiel :
                            <span>
                                {powerFormat(Math.round(bilanBatt.avant.potentielRestitution))} -&gt; {powerFormat(Math.round(bilanBatt.apres.nonRestituable))}{' '}
                                kWh
                            </span>
                        </li>
                        <li>
                            % potentiel
                            <span>
                                {powerFormat(Math.round(bilanBatt.avant.ratioPotentielRestitution * 100))} % -&gt;{' '}
                                {powerFormat(Math.round(bilanBatt.apres.ratioNonRestitution * 100))} %
                            </span>
                        </li>
                        <li>
                            Restitution
                            <span>{powerFormat(Math.round(bilanBatt.apres.restitution))} kWh</span>
                        </li>
                        <li>
                            x {currencyFormat(prixDachat, 4)}: <span>{currencyFormat(bilanBatt.apres.restitution * prixDachat)}</span>
                        </li>

                        <>
                            <li>
                                Independance:
                                <span>
                                    {powerFormat(Math.round(bilanBatt.avant.independance * 100))} % -&gt;{' '}
                                    {powerFormat(Math.round(bilanBatt.apres.independance * 100))} %
                                </span>
                            </li>
                            <li>
                                A-C production:{' '}
                                <span>
                                    {powerFormat(Math.round(bilanBatt.avant.autoconsoProd * 100))} % -&gt;{' '}
                                    {powerFormat(Math.round(bilanBatt.apres.autoconsoProd * 100))} %
                                </span>
                            </li>
                        </>
                    </>
                </DivDebug>
            </ul>
        </div>
    );
};

export default BattContainerComponent;
